import {useBreakpointValue, VStack} from "@chakra-ui/react";
import { FaMicrophone, FaGlobe, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';
import TwoColumnRow from "./TwoColumnRow";
import {useAuth} from "../../redux/AuthProvider"; // Import the reusable component

function TwoColumnLayout({theFileInput, onOpenSignUpScreen1, urlInput, setUrlInput, handleSubmit,
                             currentPlaceholder, fade}) {
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base' || breakpoint === 'sm' || breakpoint === 'md';
    const auth = useAuth();
    //test commit

    const rowsData = [
        {
            title: "Get more from your reports & documents",
            description:
                "Instantly summarize key points and find out key events or timelines. Accurately extract the info you need about officers," +
                " witnesses, discrepancies & more. Save time spent sifting through dense documents.",
            features: [
                { icon: FaMicrophone, text: "Supports scanned documents with OCR technology" },
                { icon: FaGlobe, text: "Supports up to 400-page documents with accurate page number citations" },
                { icon: FaShieldAlt, text: "Uploaded data is fully encrypted, and only you can access it." },
            ],
            buttonText: "Get started",
            mediaSrc: "/1_screenshot.jpg",
            mediaType: "image",
        },
        {
            title: "Video/Audio analysis.",
            description:
                "Have hours of footage from body-worn cameras or other videos? " +
                "Upload the video and ask questions about it. Find key interactions, statements, or events.",
            features: [
                { icon: FaMicrophone, text: "Timestamp citations so you know exactly when things occurred" },
                { icon: FaGlobe, text: "Accurate speaker identification so you know who said what" },
                { icon: FaShieldAlt, text: "State-of-the-art video transcription technology" },
            ],
            buttonText: "Get started",
            mediaSrc: process.env.PUBLIC_URL + '/BWC_Video_Demo.mov',
            mediaType: "video",
            reverse: true,
        },
        {
            title: "Upload 50+ files at once.",
            description:
                "You can upload 40 or even 50+ files at once. We can handle it.",
            features: [
                { icon: FaMicrophone, text: "Locate specific information quickly among multiple files." },
                { icon: FaGlobe, text: "Cross-compare and find contradictions between different files." },
                { icon: FaShieldAlt, text: "Clickable in-text citations that bring you to the exact page in a specific file." },
            ],
            buttonText: "Get started",
            mediaSrc: "/5_screenshot.jpg",
            mediaType: "image",
        },
        {
            title: "Accurate Transcriptions",
            description:
                "Upload any long video or audio file, such as interviews with witnesses, officers, etc.",
            features: [
                { icon: FaMicrophone, text: "Fast, accurate transcription with timestamps" },
                { icon: FaGlobe, text: "Reliable speaker labeling even with 4+ speakers and background noises" },
                { icon: FaCheckCircle, text: "Export directly to PDF or TXT for your use" },
            ],
            buttonText: "Get started",
            mediaSrc: process.env.PUBLIC_URL + '/justify_transcript_screenshot.jpg',
            mediaType: "image",
            reverse: true,
        },
        {
            title: "High-quality, accurate responses.",
            description:
                "The little things matter. We produce the highest-quality responses that are accurate, reliable, and highly detailed. " +
                "Don't opt for solutions that just glaze over your files or videos.",
            features: [
                { icon: FaMicrophone, text: "Detailed, in depth responses with zero hallucinations" },
                { icon: FaGlobe, text: "Page number citations and carefully formatted answers" },
                { icon: FaCheckCircle, text: "Closely follows your instructions" },
                { icon: FaShieldAlt, text: "Note: Video on the right doesn't use actual case material for security reasons." },
            ],
            buttonText: "Get started",
            mediaSrc: process.env.PUBLIC_URL + '/2_screenshot.mp4',
            mediaType: "video",
            reverse: false,
        },
        // {
        //     title: "Ask about an image—right in your document.",
        //     description:
        //         "Encounter a graph, diagram, or tough math equation in your document? " +
        //         "Just select it and ask a question about it.",
        //     features: [
        //         { icon: FaMicrophone, text: "Uses context from your document for a better response" },
        //         { icon: FaGlobe, text: "No need to leave the page. Works on graphs, diagrams, tables, equations, and more" },
        //     ],
        //     buttonText: "Try now!",
        //     mediaSrc: process.env.PUBLIC_URL + '/4_screenshot.mp4',
        //     mediaType: "video",
        //     reverse: true,
        // },
    ];

    return (
        <VStack spacing={isMobile ? 16 : 20} width={['96%','89%', '81%', '73%', '64%']} p={8} bg={'white'}>
            {rowsData.map((row, index) => (
                <TwoColumnRow
                    key={index}
                    title={row.title}
                    description={row.description}
                    features={row.features}
                    buttonText={!auth.isLoggedIn ? row.buttonText : "Try now!"}
                    mediaSrc={row.mediaSrc}
                    mediaType={row.mediaType}
                    reverse={row.reverse}
                    theFileInput={theFileInput}
                    onOpenSignUpScreen1={onOpenSignUpScreen1}
                    urlInput={urlInput}
                    setUrlInput={setUrlInput}
                    handleSubmit={handleSubmit}
                    currentPlaceholder={currentPlaceholder}
                    fade={fade}
                />
            ))}
        </VStack>
    );
}

export default TwoColumnLayout;
